export default __webpack_public_path__ + "static/media/retailsite.inline.dbbdcd10.svg";